<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-md-12">
      <!-- Modern Card Container -->
      <div class="card settings-card">
        <!-- Card Header -->
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="header-title">
                <h2 class="mb-0">
                  <i class="fas fa-user-clock me-2 text-primary"></i>
                  Shift Assignment - {{ departmentName }}
                </h2>
                <p class="text-muted mb-0 mt-1">
                  Configure shift timings and assign employees to day and night shifts.
                </p>
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-2" (click)="resetForm()">
                <i class="fas fa-redo me-2"></i>Reset
              </button>
              <button type="submit" class="btn btn-success" (click)="onSubmit()"
                [disabled]="shiftForm.invalid || isSaving">
                <i class="fas fa-save me-2"></i>
                {{ isSaving ? 'Saving...' : 'Save Assignment' }}
              </button>
            </div>
          </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">
          <form class="form-data" [formGroup]="shiftForm">
            <!-- Regular Working Hours Section -->
            <div class="row g-4">
              <div class="col-12">
                <div class="detail-section">
                  <h5 class="section-title"><i class="fas fa-clock me-2"></i>Regular Working Hours</h5>
                  <div class="row g-4">
                    <!-- Weekdays Work Hours -->
                    <div class="col-12 col-md-6">
                      <div class="form-group mb-3">
                        <label class="form-label">Weekdays Work Hours *</label>
                        <div class="d-flex align-items-center gap-2">
                          <select class="form-control text-center rounded" formControlName="weekdays_work_hours"
                            [class.is-invalid]="shiftForm.get('weekdays_work_hours')?.invalid && shiftForm.get('weekdays_work_hours')?.touched">
                            <option value="" disabled selected>HH</option>
                            <option *ngFor="let hour of hours" [value]="hour">
                              {{ hour < 10 ? '0' + hour : hour }} </option>
                          </select>
                          <div class="fs-4 fw-bold">:</div>
                          <select class="form-control text-center rounded" formControlName="weekdays_work_minutes">
                            <option value="" disabled selected>MM</option>
                            <option *ngFor="let minute of minutes" [value]="minute">
                              {{ minute < 10 ? '0' + minute : minute }} </option>
                          </select>
                        </div>
                        <div
                          *ngIf="shiftForm.get('weekdays_work_hours')?.invalid && shiftForm.get('weekdays_work_hours')?.touched"
                          class="text-danger mt-1">
                          Please select valid hours
                        </div>
                      </div>
                    </div>

                    <!-- Friday Work Hours -->
                    <div class="col-12 col-md-6">
                      <div class="form-group mb-3">
                        <label class="form-label">Friday Work Hours *</label>
                        <div class="d-flex align-items-center gap-2">
                          <select class="form-control text-center rounded" formControlName="friday_work_hours"
                            [class.is-invalid]="shiftForm.get('friday_work_hours')?.invalid && shiftForm.get('friday_work_hours')?.touched">
                            <option value="" disabled selected>HH</option>
                            <option *ngFor="let hour of hours" [value]="hour">
                              {{ hour < 10 ? '0' + hour : hour }} </option>
                          </select>
                          <div class="fs-4 fw-bold">:</div>
                          <select class="form-control text-center rounded" formControlName="friday_work_minutes">
                            <option value="" disabled selected>MM</option>
                            <option *ngFor="let minute of minutes" [value]="minute">
                              {{ minute < 10 ? '0' + minute : minute }} </option>
                          </select>
                        </div>
                        <div
                          *ngIf="shiftForm.get('friday_work_hours')?.invalid && shiftForm.get('friday_work_hours')?.touched"
                          class="text-danger mt-1">
                          Please select valid hours
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shift Timings Section -->
              <!-- <div class="col-12">
                <div class="detail-section">
                  <h5 class="section-title">
                    <i class="fas fa-clock me-2"></i>Shift Timings
                  </h5>
                  <div class="row g-4">
                    <ng-container *ngFor="let field of shiftTimeFields">
                      <div class="col-12 col-md-6">
                        <div class="form-group mb-3">
                          <label class="form-label">{{ field.label }} *</label>
                          <div class="d-flex align-items-center gap-2">
                            <select class="form-control text-center rounded" [id]="field.controlNameHour"
                              [formControlName]="field.controlNameHour"
                              [class.is-invalid]="shiftForm.get(field.controlNameHour)?.invalid && shiftForm.get(field.controlNameHour)?.touched">
                              <option value="" disabled selected>HH</option>
                              <option *ngFor="let hour of hours" [value]="hour">
                                {{ hour < 10 ? '0' + hour : hour }} </option>
                            </select>
                            <div class="fs-4 fw-bold">:</div>
                            <select class="form-control text-center rounded" [id]="field.controlNameMinute"
                              [formControlName]="field.controlNameMinute">
                              <option value="" disabled selected>MM</option>
                              <option *ngFor="let minute of minutes" [value]="minute">
                                {{ minute < 10 ? '0' + minute : minute }} </option>
                            </select>
                          </div>
                          <div
                            *ngIf="shiftForm.get(field.controlNameHour)?.invalid && shiftForm.get(field.controlNameHour)?.touched"
                            class="text-danger mt-1">
                            Please select valid hours
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div> -->

              <!-- Employee Assignment Section -->
              <div class="col-12">
                <div class="detail-section weekend-hours">
                  <h5 class="section-title">
                    <i class="fas fa-users me-2"></i>Employee Assignment
                  </h5>

                  <div class="row g-4">
                    <!-- Day Shift Employees -->
                    <div class="col-12 col-md-6">
                      <div class="form-group mb-3">
                        <label class="form-label">Day Shift Employees *</label>

                        <!-- 👇 clear-all + count line -->
                        <div class="d-flex justify-content-between align-items-center mt-1">
                          <small class="text-muted">
                            Selected: {{ dayEmployeesControl.value?.length || 0 }} employees
                          </small>
                          <button *ngIf="dayEmployeesControl.value?.length" type="button"
                            class="btn btn-sm btn-outline-danger clear-all-btn" (click)="clearDayEmployees()">
                            <i class="fas fa-trash-alt me-1"></i>
                            Clear all
                          </button>
                        </div>

                        <ng-select class="ng-select" [formControl]="dayEmployeesControl" [multiple]="true"
                          [items]="employeeDropdown" bindLabel="employee_name" [compareWith]="compareEmployees"
                          placeholder="Select day shift employees" [closeOnSelect]="false" (change)="employeeSelect()"
                          [class.is-invalid]="shiftForm.get('day_shift_employees')?.invalid && shiftForm.get('day_shift_employees')?.touched">

                          <!-- Compact summary instead of many chips -->
                          <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value">
                              <span class="ng-value-label text-muted" *ngIf="items.length === 0">
                                Select day shift employees
                              </span>
                              <span class="ng-value-label" *ngIf="items.length > 0">
                                {{ items.length }} employee(s) selected
                              </span>
                            </div>
                          </ng-template>
                        </ng-select>



                        <!-- Scrollable list of selected day-shift employees -->
                        <div class="mt-2">
                          <div *ngIf="dayEmployeesControl.value?.length; else noDaySelected">
                            <div class="employee-list">
                              <div class="employee-row" *ngFor="let emp of dayEmployeesControl.value">
                                <span class="employee-name">{{ emp.employee_name }}</span>
                                <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                                  (click)="removeDayEmployee(emp)" title="Remove from day shift">
                                  <i class="fas fa-times-circle"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <ng-template #noDaySelected>
                            <small class="text-muted">No employees selected yet</small>
                          </ng-template>
                        </div>
                      </div>
                    </div>

                    <!-- Night Shift Employees -->
                    <div class="col-12 col-md-6">
                      <div class="form-group mb-3">
                        <label class="form-label">Night Shift Employees</label>

                        <!-- 👇 clear-all + count line -->
                        <div class="d-flex justify-content-between align-items-center mt-1">
                          <small class="text-muted">
                            Selected: {{ nightEmployeesControl.value?.length || 0 }} employees
                          </small>
                          <button *ngIf="nightEmployeesControl.value?.length" type="button"
                            class="btn btn-sm btn-outline-danger clear-all-btn" (click)="clearNightEmployees()">
                            <i class="fas fa-trash-alt me-1"></i>
                            Clear all
                          </button>
                        </div>

                        <ng-select class="ng-select" [formControl]="nightEmployeesControl" [multiple]="true"
                          [items]="employeeDropdown" bindLabel="employee_name" [compareWith]="compareEmployees"
                          placeholder="Select night shift employees" [closeOnSelect]="false"
                          (change)="employeeSelect()">

                          <!-- Compact summary instead of many chips -->
                          <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value">
                              <span class="ng-value-label text-muted" *ngIf="items.length === 0">
                                Select night shift employees
                              </span>
                              <span class="ng-value-label" *ngIf="items.length > 0">
                                {{ items.length }} employee(s) selected
                              </span>
                            </div>
                          </ng-template>
                        </ng-select>

                        <!-- Scrollable list of selected night-shift employees -->
                        <div class="mt-2">
                          <div *ngIf="nightEmployeesControl.value?.length; else noNightSelected">
                            <div class="employee-list">
                              <div class="employee-row" *ngFor="let emp of nightEmployeesControl.value">
                                <span class="employee-name">{{ emp.employee_name }}</span>
                                <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                                  (click)="removeNightEmployee(emp)" title="Remove from night shift">
                                  <i class="fas fa-times-circle"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <ng-template #noNightSelected>
                            <small class="text-muted">No employees selected yet</small>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Saved data from department details (if any) -->
                  <div class="row g-4 mt-3" *ngIf="savedDayShiftEmployees.length || savedNightShiftEmployees.length">
                    <div class="col-12">
                      <h6 class="text-muted mb-2">
                        <i class="fas fa-info-circle me-2"></i>
                        Saved shift assignments (from department details)
                      </h6>
                    </div>

                    <div class="col-12 col-md-6" *ngIf="savedDayShiftEmployees.length">
                      <div class="card card-body p-3 shadow-sm">
                        <h6 class="mb-2">Saved Day Shift Employees</h6>
                        <ul class="mb-0 ps-3">
                          <li *ngFor="let emp of savedDayShiftEmployees">
                            {{ emp.employee_name }}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="col-12 col-md-6" *ngIf="savedNightShiftEmployees.length">
                      <div class="card card-body p-3 shadow-sm">
                        <h6 class="mb-2">Saved Night Shift Employees</h6>
                        <ul class="mb-0 ps-3">
                          <li *ngFor="let emp of savedNightShiftEmployees">
                            {{ emp.employee_name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Weekly Working Days Section -->
              <!-- <div class="col-12">
                <div class="detail-section">
                  <div class="d-flex justify-content-between align-items-center section-title">
                    <span><i class="fas fa-calendar-week me-2"></i>Weekly Working Days</span>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="fillAllTimes()">
                      <i class="fas fa-copy me-1"></i>Fill All Days
                    </button>
                  </div>
                  <div class="weekdays-grid-list">
                    <div *ngFor="let day of weeKDays" class="weekday-row">
                      <mat-checkbox [checked]="day.checked" (change)="weekSelected(day)" class="day-checkbox">
                        {{ day.week }}
                      </mat-checkbox>

                      <div class="day-time-row" *ngIf="day.checked">
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workin_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workout_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_in_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_out_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <ng-template #weekGrid let-days="days" let-title="title" let-isNight="isNight">
                <div class="detail-section">
                  <div class="d-flex justify-content-between align-items-center section-title">
                    <span><i class="fas fa-calendar-week me-2"></i>{{ title }}</span>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="fillAllTimes(days)">
                      <i class="fas fa-copy me-1"></i>Fill All Days
                    </button>
                  </div>
                  <div class="weekdays-grid-list">
                    <div *ngFor="let day of days" class="weekday-row">
                      <mat-checkbox [checked]="day.checked" (change)="weekSelected(day)" class="day-checkbox">
                        {{ day.week }}
                      </mat-checkbox>

                      <div class="day-time-row" *ngIf="day.checked">
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workin_time"
                            (ngModelChange)="day.last_edited = 'in'" [ngModelOptions]="{standalone: true}"
                            [class.is-invalid]="isNight && isNightTimeInvalid(day) && day.last_edited === 'in'">
                          <div class="text-danger small mt-1"
                            *ngIf="isNight && isNightTimeInvalid(day) && day.last_edited === 'in'">
                            Work in must be greater than Work out
                          </div>
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workout_time"
                            (ngModelChange)="day.last_edited = 'out'" [ngModelOptions]="{standalone: true}"
                            [class.is-invalid]="isNight && isNightTimeInvalid(day) && day.last_edited !== 'in'">
                          <div class="text-danger small mt-1"
                            *ngIf="isNight && isNightTimeInvalid(day) && day.last_edited !== 'in'">
                            Work out must be less than Work in
                          </div>
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_in_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_out_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <!-- <div class="text-danger small w-100" *ngIf="isNight && isNightTimeInvalid(day)">
                          Night shift: Work in time must be greater than Work out time
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>

              <div class="col-12">
                <ng-container
                  *ngTemplateOutlet="weekGrid; context: { days: dayShiftDays, title: 'Day Shift Weekly Schedule' }"></ng-container>
              </div>
              <div class="col-12">
                <ng-container
                  *ngTemplateOutlet="weekGrid; context: { days: nightShiftDays, title: 'Night Shift Weekly Schedule', isNight: true }"></ng-container>
              </div>

              <!-- Employee Assignment Section -->

            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>